import axios, { type AxiosError } from 'axios';
import { apiUrl } from '@/constants/environment';
import type { ApiResponseError } from '@/types';

const axiosInstance = axios.create({
  baseURL: apiUrl,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error: AxiosError<ApiResponseError>['response']) => Promise.reject(error),
);
export default axiosInstance;
